import React,{ useContext, useState, useEffect} from 'react';
import L1 from './Im/L1.png'
import google from './Im/google.png'
import './Log.css';
import { Link, BrowserRouter as Router, Route, Switch, NavLink ,Redirect, useHistory} from "react-router-dom";
// import Signup from './Sign';
import wallet_close from "../Wallet_pg/Im/wallet_close.png";
import { AuthContext } from "../Auth";
import firebaseConfig from '../fire';
import { Spinner } from '../Components/Spinner';
import {useAuthState} from 'react-firebase-hooks/auth';
import Googlelogin from '../Components/Googlelogin.js';
import { auth } from '../fire';
import { render } from 'react-dom';
import { CircularProgress, Button } from '@material-ui/core';
import ColoredLinearProgress from '../Components/LineProgress';
import { toast } from 'react-toastify';


/* check if user is logged in  and redirect to profile page */
const checkUser = firebaseConfig.auth().currentUser;
if (checkUser) {
  Window.location.href = "/profile";
}

const previousUrl = localStorage.getItem('currentUrl');
// console.log(previousUrl);

function GoogleSignIn() {
  const [user, loading, error] = useAuthState(auth);
  if (loading) {
    return <Spinner />;
  }
  if (error) {
    return <p>Error: {error.message}</p>;
  }
  if (user) {
    return <p>Welcome {user.displayName}</p>;
  }
  return <Googlelogin />;
}

const Login = () => {
  
  let history = useHistory();
  // const [ loggedInSate, setLoggedInSate ] = useState();
  const errorMsgEl = document.getElementById('error-msg');
  const [error, setError] = useState();
  const handleSubmit = (e) => {
    e.preventDefault();
  //  setLoggedInSate("Logging in")
    let email = document.querySelector("#email").value;
    let password = document.querySelector("#password").value;

   const Login =firebaseConfig.auth().signInWithEmailAndPassword(email, password)

   .then((userCredential) => {
    // Signed in 
    const user = userCredential.user;
    console.log(user);
    // ...
  })
  .catch((error) => {
    const errorCode = error.code;
    const errorMessage = error.message;
    setError(errorCode);
   // console.log('error message', errorMessage);
  
  });
  };
  //console.log(error);
  switch(error){
    case 'auth/invalid-email':  errorMsgEl.innerHTML = `<p class="error-msg">Invalid email address</p>`; break; 
    case 'auth/user-not-found' : errorMsgEl.innerHTML = `<p class="error-msg">User not found</p>`; break;
    case 'auth/wrong-password' : errorMsgEl.innerHTML = `<p class="error-msg">Wrong password</p>`; break;
  }
 
  
  const { currentUser } = useContext(AuthContext);

  /* check if user is email verified */
  if (currentUser && currentUser.emailVerified === true) {
    return <Redirect to={previousUrl} />;
  }
  else if (currentUser && currentUser.emailVerified === false) {
    // sign out user
    firebaseConfig.auth().signOut();
    toast.error("Please verify your email address");
  }
  else if (!currentUser) {
  }

  
  return (
 
      <div className="all">
       {/* {loggedInSate === "Logging in" ? <Spinner /> : ""} */}
        <img className="rajini rajini-mobile" src={L1} alt="Logo" />;
        <div className="login">
        <div><Link to="/"><img className="close-login" src={wallet_close} alt="Logo" /></Link></div>
        <div className="google-login-pg">
        <Googlelogin />
        </div>
         <br></br><br></br><br></br>
         <div id="error-msg"></div>
          <form className="form" onSubmit={handleSubmit}>
            <label>Email</label>
            <br></br>
            <input className="textbox" type="text" id="email" placeholder="Enter your email"></input>
            <br></br><br></br><br></br>
            <label>Password</label>
            <br></br>
            <input className="textbox" type="password" id="password" placeholder="Password"></input><br></br><br></br><br></br>
            <Link to="/resetpass" className="forget">Forgot password?</Link>
            <Link className="signup-text" to="/signup">Signup</Link><br></br>
             <button className="bn632-hover bn21">SIGN IN</button>
          </form>
        </div>
      </div>
 
    )
}
function ButtonComponent(props) {
  const { onClick, loading } = props;
  return null
}
class LoadingButton extends React.Component {
  constructor() {
    super();
    this.state = { loading: false };
  }

  onClick = () => {
    this.setState({ loading: true });
    setTimeout(() => this.setState({ loading: false }), 3000); //3 seconds
  };

  render() {
    return (
      <React.Fragment>
        {this.state.loading && <ColoredLinearProgress />}
        <br />
        <ButtonComponent onClick={this.onClick} loading={this.state.loading} />
      </React.Fragment>
    );
  }
}

const rootElement = document.querySelector('#root');
if (rootElement) {
  render(<LoadingButton />, rootElement);
}
export default Login

